import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Main from 'layouts/Main';
import Container from 'components/Container';
import { Commerce, ComputerScience, Day1, Delta, Kannada, Kshitij, Radical, Valediction } from 'views/GoonjImages/components';
import Mun from 'views/GoonjImages/components/Mun/Mun';

import GoonjImages from 'views/GoonjImages';


const FaqGroupItem = ({ tittle, items }) => {
  const theme = useTheme();
  return (
    <Main>
      <Box>
        <br></br>
        <Typography  variant='h4' align='center' fontWeight={800}>
          GOONJ 2023
        </Typography>
        <br></br>
        <br></br>

        <Typography variant='h6' align='center' fontWeight={700}>
          INTRODUCTION
        </Typography>

        <Box id='Day1' marginBottom={2} marginLeft={3} marginRight={3}>
          <br></br>
          <Typography
            variant={'subtitle1'}
            align='justify'

          >
            National Public School, Yeshwanthpur, Bangalore organised the fifth edition of its mega interschool event ‘Goonj’ on 21st and 22nd July 2023. The sole objective of this vibrant extravaganza was to promote, foster and stimulate the latent talent of students. It provided them with the platform to showcase their creativity and give wings to their imagination.
            <br></br>
            <br></br>
            The fest this year saw a record participation of more than 600 students from twenty-one eminent schools of the city. The event comprised of a plethora of sixteen multi- disciplinary events from ten departments. The participants prepared meticulously and tried to out shine each other zealously, in the events like MUN, Debattle, Mad Act, Nrithyarupakam, Rangometry, Science Walk, Hackathon to name a few. Their excitement, vivacity and brilliance reflected in their performances.
            <br></br>
            <br></br>
            The two days enriching saga culminated with the much awaited prize distribution ceremony. The rolling trophy was awarded to <b>Presidency School, Nandini Layout </b>which walked away with the maximum prizes.
          </Typography>
          <br></br>
          <Typography variant='h6' align='center' id='Day1' fontWeight={700}>
            DAY 1
          </Typography>
          <Day1 />
        </Box>

        <Box>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >KSHITIJ (Nritya Rupakam) </Typography>
              <Typography align='right'> - An awe-inspiring spectacle of art, spirituality and cultural heritage</Typography>

            </Box>
            <AccordionDetails>
              An exquisite artistic representation that intertwines storytelling, music and dance to bring alive the richness of ancient Hindu myths and epics. The performances showcased the cultural heritage and spiritual depth of our epics with mesmerizing choreography and compelling narrative in Sanskrit.

            </AccordionDetails>

            <Kshitij />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>

          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >KANNADA CHETHANA (Debate) </Typography>
              <Typography align='right' > - Engage in responsible dialogues, listen conscientiously and discern right from the wrong</Typography>

            </Box>
            <AccordionDetails>
              The art of ‘Debating’ is finely linked to truth and oration, which can positively influence the listener to make the right choices. The participant hones the skill at being persuasive, thinks critically, and appreciates divergent views with and. The Debate in Kannada proved that language is not a barrier when one needs to effectively communicate one’s opinions.
            </AccordionDetails>

            <Kannada />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >RADICAL - RANGOMETRY (Math Art) </Typography>
              <Typography align='right' >- A usual rangoli explaining the hidden mathematical concepts</Typography>

            </Box>
            <AccordionDetails>
              Art in math is a fascinating and often the overlooked aspect of the subject. From geometric shapes to Fibonacci sequence, Chaos theory to Music theory, math and art intersect in many ways. Rangometry is an art-integrated display, analyzing creativity through the perception of Math. Rangometry widened our perceptive by looking at art through the lens of Math.
            </AccordionDetails>

            <Radical />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >DELTA – SCIENCE ACT </Typography>
              <Typography align='right' >- Lending scientific concepts with dramatic storytelling</Typography>

            </Box>
            <AccordionDetails>
              Combing science and drama can develop a deeper understanding of scientific concepts while honing the creativity, teamwork and performance skills. It offers an excellent platform for encouraging inter-disciplinary learning and fostering passion for both science and the arts. Science Act witnessed complex concepts presented innovatively through the medium of drama.
            </AccordionDetails>

            <Delta />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >NPS YPR MUN </Typography>
              <Typography align='right' >- On the path of becoming global citizens</Typography>

            </Box>
            <AccordionDetails>
              Model United Nations is an educational simulation where students typically role-play as delegates representing different countries and international organization in simulated sessions of the United Nations (UN). The competition promotes deeper understanding of international relations and diplomacy. It was a dream come true, as National Public School, Yeshwanthpur launched its very first NPS YPR MUN.
            </AccordionDetails>

            <Mun />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >COMMERCE – EXODIA </Typography>
              <Typography align='right' >- The lifeblood of economies and catalyst for progress</Typography>

            </Box>
            <AccordionDetails>
              Commerce is a core component of any successful society. The competitions gave an insight on the importance of financial literacy in real world by implications of trading, skills of crisis management and the ability to resolve corporate cases in the court of law.
            </AccordionDetails>

            <Commerce />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left' >COMPUTER SCIENCE – SPACEBAR (Byte brawl) </Typography>
              <Typography align='right' >- Let the Byte brawl begin</Typography>

            </Box>
            <AccordionDetails>
              The competition aimed at fostering a spirit of healthy competition among participants while showcasing their problem-solving and coding skills. Designing an interactive, simple and user-friendly Graphical User Interface (GUI) helped to enhance creativity, critical thinking and logical thinking.
            </AccordionDetails>

            <ComputerScience />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}>VALEDICTION CEREMONY</Typography>

            </Box>
            <AccordionDetails>

            </AccordionDetails>

            <Valediction />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day1" sx={{ ml: 'auto' }}>Back to DAY 1</a>
            </Box>
          </Box>

          <GoonjImages/>

        </Box>
      </Box>
    </Main>
  );
};

FaqGroupItem.propTypes = {
  tittle: PropTypes.string,
  items: PropTypes.array.isRequired,
};

const Goonj = () => {
  return (
    <Box>
      <Box marginBottom={1}>
        <FaqGroupItem
          items={[
            
          ]}
        />
      </Box>
    </Box>
  );
};

export default Goonj;